import userRepo from '../repos/userRepo'
import userService from '../services/userService'
import userApi from '../api/userApi'
import { GlobalAdminAccessRight } from '@/helpers/globalAdminAccessRight.js';
import authService from '../services/authService'
import { FarmAdminAccessRight } from '../helpers/globalAdminAccessRight';

export default {
    namespaced: true,
    state: {
        user: null,
        access: [],
        menu: null,
        sitePages: []
    },
    getters: {
        isGlobalAdmin(state) {
            if(state.user) {
                return state.user.IsGlobalAdmin;
            }

            return false;
        },
        getFullName(state) {
            if(state.user) {
                return state.user.FullName;
            }

            return "";
        },
        getPersonnelID(state){
            if(state.user){
                return state.user.PersonnelID;
            }

            return -1;
        },
        primaryPlantID(state) {
            if(state.user){
                return state.user.PrimaryPlantID;
            }

            return null;
        },
        isLoaded(state) {
            return state.user != null;
        },
        isAuthorised: state => permissions => {
            var accessRights = permissions.accessRights;
            var path = permissions.path;
            let isAuthorised = false;

            // Check if we have user details
            if(state.user) {
                // Start by assuming we are authorised (provided we are about to loop through some access rights)
                isAuthorised = accessRights.length > 0;
                // Iterate through the required access rights
                for(var accessRight of accessRights) {
                    let userHasAccessRight;

                    // Process an access right with a plant pairing
                    if(typeof accessRight == "object") {

                        // Handle if this is checking for the admin access right
                        if (accessRight.Access === GlobalAdminAccessRight || accessRight.Access === FarmAdminAccessRight){
                            if(path != null) {
                                var sitePage = state.sitePages.filter(s => s.Href != null).find(st => st.Href.includes(path));
                                // If site page has required farm type id
                                if (sitePage && sitePage.FarmTypeIDs.length > 0) {
                                    // check if user is the farm admin
                                    if(state.user.AdminFarmTypeIDs == null || state.user.AdminFarmTypeIDs.length == 0) {
                                        isAuthorised = false;
                                    } else if (sitePage.FarmTypeIDs.some(ft => state.user.AdminFarmTypeIDs.some(aft => aft == ft))) {
                                        isAuthorised = true;
                                    } else {
                                        isAuthorised = false
                                    }
                                }
                            }
                            
                            if (accessRight.Access === GlobalAdminAccessRight) {
                                userHasAccessRight = state.user.IsGlobalAdmin;
                            }
                            continue;
                        }
                        

                        // Check if the user has this access right for this plant
                        userHasAccessRight = state.access.find(a => a.Access == accessRight.Access && a.PlantID == accessRight.PlantID);

                    // Process an access right without a plant pairing
                    } else {
                        // Handle if this is checking for the admin access right
                        if (accessRight === GlobalAdminAccessRight || accessRight === FarmAdminAccessRight) {
                            if(path != null) {
                                sitePage = state.sitePages.filter(s => s.Href != null).find(st => st.Href.includes(path));

                                // If site page has required farm type id
                                if(sitePage && sitePage.FarmTypeIDs.length > 0) {
                                    // check if user is the farm admin
                                    if (state.user.AdminFarmTypeIDs == null || state.user.AdminFarmTypeIDs.length == 0) {
                                        isAuthorised = false;
                                    } else if (sitePage.FarmTypeIDs.some(ft => state.user.AdminFarmTypeIDs.some(aft => aft == ft))) {
                                        isAuthorised = true;

                                    } else {
                                        isAuthorised = false
                                    }
                                }
                            }
                            
                            if (accessRight === GlobalAdminAccessRight) {
                                userHasAccessRight = state.user.IsGlobalAdmin;
                            }
                            continue;
                        }

                        // Check if the user has this access right
                        userHasAccessRight = state.access.find(a => a.Access == accessRight);
                    }

                    // Check if we remain authorised
                    isAuthorised = isAuthorised && userHasAccessRight != null;  
                }

                // Check if we override our authorisation by being global admin
                isAuthorised = isAuthorised || state.user.IsGlobalAdmin;

            }

            return isAuthorised;
        },
        getMenu(state) {
            return state.menu;
        }
    },
    mutations: {
        updateUser(state, value) {
            state.user = value;
        },
        updateAccess(state, value) {
            state.access = value;
        },
        updateMenu(state, value) {
            state.menu = value;
        },
        updateSitePages(state, value) {
            state.sitePages = value;
        },        
        removeUser(state) {
            state.user = null;
        },
        removeAccess(state) {
            state.access = null;
        },
        removeMenu(state) {
            state.menu = null;
        },
        removeSitePages(state) {
            state.sitePages = [];
        }
    },
    actions: {
        async loadUserAsync({ commit }) {
            // Try to load the user from the server and if we go offline then just continue and try to load user from indexdb.
            await userService.fetchAndStoreUser()

            // Load user from indexdb
            let user = await userRepo.getUser();
            commit('updateUser', user);

            // Load access writes from indexdb
            let access = await userRepo.getAccess();
            commit('updateAccess', access);

            // Load menu from Server
            let menu = await userApi.getUserMenu();
            commit('updateMenu', menu);

            // Load site pages from Server
            let sitePages = await userApi.getSitePages();
            commit('updateSitePages', sitePages);
        },
        async clearUserCache({ commit }) {
            // Remove the user from indexdb
            await userRepo.clearUser();
            await userRepo.clearAccess();

            commit('removeUser');
            commit('removeAccess');
            commit('removeMenu');
            commit('removeSitePages')
        },
        async acquireImageAuthToken(){
            let tokenResponse = await authService.acquireToken();
            if(tokenResponse != null && tokenResponse.tokenError != null){
                return null;
            }

            return tokenResponse;
        },
    }
}